import React from "react";
import { AiOutlineSearch } from "react-icons/ai";

const AllSearch = (props) => {

    const Input = props.Input;
    const handleChange = props.handleChange

    return (
        <>
            <form className="d-flex" role="search">
                <input
                    className="form-control me-2"
                    type="search"
                    placeholder="Search JobSeeker"
                    aria-label="Search"
                    value={Input}
                    onChange={handleChange}
                />
                <div className="searchicon" style={{ position: 'relative', right: '6%', top: '6px' }}>
                    <AiOutlineSearch size={25} />
                </div>
            </form>
        </>
    );
};

export default AllSearch;
